<template>
  <Transition name="slidein-animation">
    <div
      v-show="isOpened"
      class="slidein"
      @click.self="closeSlideInFromOverlay"
    >
      <div class="slidein-container">
        <div class="slidein-title">
          <slot name="header" />
          <button class="btn btn--close btn-modal-close" @click="closeSlideIn" />
        </div>
        <div class="slidein-content slide-content">
          <slot name="body" />
        </div>
        <div class="slidein-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { UserAuth } from '@tools/user/auth';

/**
 * Init Slide-In component
 */
export default {
  props: {
    isOpened: { type: Boolean, default: false },
    isClosableFromOverlay: { type: Boolean, default: true },
  },
  /**
   * add no-scroll class on body when modal is opened,
   * in order to avoid scrolling issues
   */
  watch: {
    isOpened() {
      /**
       * @see https://bureaux-a-partager.atlassian.net/browse/MATCH-6447
       * @todo remove once https://bureaux-a-partager.atlassian.net/browse/MATCH-6498 is done
       */
      if (!UserAuth.isImpersonated()) {
        document.body.classList.toggle('no-scroll');
      }
    },
  },
  mounted() {
    // trigger onClose method on Esc press
    document.addEventListener('keydown', (e) => {
      if (this.isOpened && e.code === 'Escape') {
        this.closeSlideIn();
      }
    });
  },
  methods: {
    /**
     * Method triggered on button click
     * Trigger the close method of the parent
     */
    closeSlideIn() {
      this.$emit('close');
    },
    /**
     * Method triggered on overlay click
     */
    closeSlideInFromOverlay() {
      if (!this.isClosableFromOverlay) {
        return;
      }

      this.closeSlideIn();
    },
  },
};
</script>
